/**
* Animates cards opacity for ease-in rendering.
*
* @param delay - Rendering delay between one card and another
*/
const initCardsAnimation = (delay, cardsToAnimateNodeList) => {
    if (!cardsToAnimateNodeList) {
        cardsToAnimateNodeList = document.querySelectorAll("[data-animate-opacity]");
    }
    if (cardsToAnimateNodeList && cardsToAnimateNodeList.length > 0) {
        cardsToAnimateNodeList.forEach((card, index) => {
            if (card.hasAttribute("data-animate-opacity")) {
                imagesLoaded(card, () => {
                    setTimeout(() => {
                        card.classList.add("active");
                    }, delay * index);
                });
            }
        });
    }
};
